import { DOMAttributes } from "react";
import * as React from "react";

import { Icon, IconsEnum } from "components/icon";

import { itemContentWrapper, tagArrow, tagName, tagResponsesCount } from "./styles";

interface IProps {
  count: number;
  index: number;
  name: string;
  onClick: DOMAttributes<HTMLDivElement>["onClick"];
  onMouseEnter: DOMAttributes<HTMLDivElement>["onMouseEnter"];
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line react/display-name
export const CannedResponseTagItem: React.FC<IProps> = React.memo(({ count, index, name, onMouseEnter, onClick }) => (
  <div
    data-testid={`shortcut-item-${name}`}
    css={itemContentWrapper}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    data-index={index}
  >
    <div data-testid="canned-responses-count" css={tagResponsesCount}>
      {count}
    </div>
    <div data-testid="shourtcut-name" css={tagName}>
      {name}
    </div>
    <Icon
      data-testid="shortcut-select-button"
      css={tagArrow}
      name={IconsEnum.ArrowRightShort}
      width="4px"
      height="8px"
      fill="#000000"
    />
  </div>
));
